const handsOnQuestionTypes = [
  {
    label: "图像分类",
    value: 1,
    params: {
      type: "file",
      fileTypes: ["jpg", "jpeg", "png", "gif", "bmp", "webp"],
      maxSize: 10,
      title:
        "识别图片中的物体或场景，分配正确类别标签。评分依据为分类的准确性。"
    }
  },
  {
    label: "图像标注",
    value: 2,
    params: {
      type: "file",
      fileTypes: ["jpg", "jpeg", "png", "gif", "bmp", "webp"],
      maxSize: 10,
      title:
        "根据给定图像，考生需使用边界框标注物体，并正确分配类别标签。评分基于标注的准确性和完整性。"
    }
  },
  {
    label: "图像分割",
    value: 7,
    params: {
      type: "file",
      fileTypes: ["jpg", "jpeg", "png", "gif", "bmp", "webp"],
      maxSize: 10,
      title:
        "对图像每个像素进行语义分割并标注类别，评分基于分割区域的准确性及物体边缘的清晰度。"
    }
  },
  {
    label: "视频识别",
    value: 3,
    params: {
      type: "file",
      maxSize: 50, // MB
      fileTypes: ["mp4", "avi", "mov", "mkv"],
      title:
        "识别视频中的主要活动或动作，分配正确类别标签。评分依据为动作识别的准确性及视频理解。"
    }
  },
  {
    label: "音频识别",
    value: 4,
    params: {
      type: "file",
      maxSize: 10, // MB
      fileTypes: ["mp3", "wav", "ogg", "aac"],
      title:
        "根据音频特征进行分类并标注类别，评分标准为音频特征捕捉和分类准确性。"
    }
  },
  {
    label: "时序检测",
    value: 5,
    params: {
      type: "text",
      title:
        "考生需标注出与指标属性不匹配的异常点，评分标准为标注的准确性与合理性。"
    }
  },
  { label: "简答题", value: 6, params: { type: "text" } }
];
const examLevel = [
  { label: "初级", value: 1 },
  { label: "中级", value: 2 },
  { label: "高级", value: 3 }
];
const getExamLabel = val => {
  if (!val || ![1, 2, 3].includes(Number(val))) return "";
  return val ? examLevel.find(item => item.value === val).label : "";
};
export { handsOnQuestionTypes, examLevel, getExamLabel };



// WEBPACK FOOTER //
// ./src/utils/dict.js